import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMarketExprtOutputSettingsPanel extends Layout {
    checkbox10: Checkbox;
    checkbox11: Checkbox;
    checkbox12: Checkbox;
    checkbox13: Checkbox;
    checkbox14: Checkbox;
    checkbox15: Checkbox;
    checkbox16: Checkbox;
    checkbox17: Checkbox;
    checkbox18: Checkbox;
    checkbox19: Checkbox;
    checkbox1: Checkbox;
    checkbox20: Checkbox;
    checkbox21: Checkbox;
    checkbox22: Checkbox;
    checkbox23: Checkbox;
    checkbox24: Checkbox;
    checkbox25: Checkbox;
    checkbox26: Checkbox;
    checkbox27: Checkbox;
    checkbox28: Checkbox;
    checkbox29: Checkbox;
    checkbox2: Checkbox;
    checkbox30: Checkbox;
    checkbox31: Checkbox;
    checkbox32: Checkbox;
    checkbox33: Checkbox;
    checkbox34: Checkbox;
    checkbox35: Checkbox;
    checkbox36: Checkbox;
    checkbox37: Checkbox;
    checkbox38: Checkbox;
    checkbox39: Checkbox;
    checkbox3: Checkbox;
    checkbox40: Checkbox;
    checkbox41: Checkbox;
    checkbox42: Checkbox;
    checkbox43: Checkbox;
    checkbox44: Checkbox;
    checkbox45: Checkbox;
    checkbox46: Checkbox;
    checkbox47: Checkbox;
    checkbox48: Checkbox;
    checkbox4: Checkbox;
    checkbox5: Checkbox;
    checkbox6: Checkbox;
    checkbox7: Checkbox;
    checkbox8: Checkbox;
    checkbox9: Checkbox;
    checkboxActualDelivery: Checkbox;
    checkboxActualPickup: Checkbox;
    checkboxBrkTotalPaid: Checkbox;
    checkboxCarrierLoading: Checkbox;
    checkboxCarrierPayAdjustment: Checkbox;
    checkboxCarrierStopPay: Checkbox;
    checkboxCarrierType: Checkbox;
    checkboxCommodity: Checkbox;
    checkboxConsigneeAddress: Checkbox;
    checkboxCubicFeet: Checkbox;
    checkboxCustAccessorials: Checkbox;
    checkboxCustFuelSurcharge: Checkbox;
    checkboxCustStopCharges: Checkbox;
    checkboxDeliveryAppt: Checkbox;
    checkboxDeliveryApptTime: Checkbox;
    checkboxDestAppEnd: Checkbox;
    checkboxDestCity: Checkbox;
    checkboxDestState: Checkbox;
    checkboxDestZip: Checkbox;
    checkboxDispatcher: Checkbox;
    checkboxFreightClass: Checkbox;
    checkboxFreightValue: Checkbox;
    checkboxHazmat: Checkbox;
    checkboxLinearFeet: Checkbox;
    checkboxLoadNumber: Checkbox;
    checkboxLocationName: Checkbox;
    checkboxMiscNames: Checkbox;
    checkboxMode: Checkbox;
    checkboxMoveDistance: Checkbox;
    checkboxOperationsUser: Checkbox;
    checkboxOrderBookTm: Checkbox;
    checkboxOriginCity: Checkbox;
    checkboxOriginState: Checkbox;
    checkboxOriginZip: Checkbox;
    checkboxPayDate: Checkbox;
    checkboxPaymentTerms: Checkbox;
    checkboxPickupAppt: Checkbox;
    checkboxPickupApptEnd: Checkbox;
    checkboxPickupApptTime: Checkbox;
    checkboxScacCode: Checkbox;
    checkboxServiceLevel: Checkbox;
    checkboxShipmentExcpt: Checkbox;
    checkboxShipperAddress: Checkbox;
    checkboxSpotOrContract: Checkbox;
    checkboxTotalPaid: Checkbox;
    checkboxTotalPickups: Checkbox;
    checkboxTotalStopOffs: Checkbox;
    checkboxTrailerDetail: Checkbox;
    checkboxTrailerType: Checkbox;
    checkboxUnitCount: Checkbox;
    checkboxUnitsType: Checkbox;
    checkboxWeight: Checkbox;
    checkboxmPactUnitCount: Checkbox;
    labelOutputSettings: Label;
    panel10: Panel;
    panel11: Panel;
    panel12: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    panel6: Panel;
    panel8: Panel;
    panel9: Panel;
    panelGreenscreens: Panel;
    panelMpact: Panel;
    sourceMarketrateExprt: DataSource;
    textboxCarrierName: Textbox;
    textboxConsigneeName: Textbox;
    textboxCustomerName: Textbox;
    textboxShipperName: Textbox;
}
